// extracted by mini-css-extract-plugin
module.exports = {"container":"DietlyWidget_container__2vc8V"};